/* Earthling theme JS: cart drawer, buy boxes, accordions, videos, reveal */
(function () {
  var TH = (document.documentElement.lang || '').toLowerCase().indexOf('th') === 0;
  var THB = function (cents) {
    return '฿' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 2 }).replace(/\.00$/, '');
  };

  /* ---------- Cart drawer ---------- */
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function isGiftLine(it) { return !!(it.properties && it.properties._gift); }

  function renderCart(cart) {
    var list = qs('#em-cart-items');
    var count = qs('#em-cart-count');
    var subtotal = qs('#em-cart-subtotal');
    if (count) { count.textContent = cart.item_count; count.style.display = cart.item_count ? 'flex' : 'none'; }
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<div style="text-align:center;padding:60px 20px;color:#6D7A63;font-weight:600;">' + (TH ? 'ตะกร้าของคุณว่างเปล่า<br><br>เห็ดกำลังรออยู่' : 'Your cart is empty.<br><br>Mushrooms are waiting.') + '</div>';
    } else {
      list.innerHTML = cart.items.map(function (it) {
        var gift = isGiftLine(it);
        var controls = gift
          ? '<div style="display:inline-flex;align-items:center;background:#EAF4D4;border-radius:99px;padding:4px 12px;font-size:11px;font-weight:800;color:#0B5A2B;">' + (TH ? 'ของขวัญฟรี 🎁' : 'FREE GIFT 🎁') + '</div>'
          : '<div style="display:inline-flex;align-items:center;background:#F1EAD8;border-radius:99px;">' +
              '<button data-em-qty="' + it.key + '|' + (it.quantity - 1) + '" style="width:28px;height:28px;border:none;background:none;font-weight:800;color:#0B5A2B;cursor:pointer;">−</button>' +
              '<span style="min-width:22px;text-align:center;font-size:13px;font-weight:800;">' + it.quantity + '</span>' +
              '<button data-em-qty="' + it.key + '|' + (it.quantity + 1) + '" style="width:28px;height:28px;border:none;background:none;font-weight:800;color:#0B5A2B;cursor:pointer;">+</button>' +
            '</div>' +
            '<button data-em-qty="' + it.key + '|0" style="border:none;background:none;font-size:12px;color:#9B9784;font-weight:600;cursor:pointer;text-decoration:underline;">' + (TH ? 'ลบ' : 'Remove') + '</button>';
        var priceCell = gift
          ? '<div style="white-space:nowrap;text-align:right;"><div style="font-weight:800;font-size:14px;color:#0B5A2B;">' + (TH ? 'ฟรี' : 'FREE') + '</div><div style="font-size:11px;color:#9B9784;text-decoration:line-through;">' + THB(it.final_line_price) + '</div></div>'
          : '<div style="font-weight:800;font-size:14px;color:#0B5A2B;white-space:nowrap;">' + THB(it.final_line_price) + '</div>';
        return '<div style="display:flex;gap:14px;padding:14px 0;border-bottom:1px solid rgba(11,90,43,0.1);">' +
          '<img src="' + (it.image || '') + '" alt="" style="width:64px;height:64px;object-fit:cover;border-radius:12px;background:#F1EAD8;flex-shrink:0;">' +
          '<div style="flex:1;min-width:0;">' +
            '<div style="font-weight:700;font-size:14px;color:#16321F;line-height:1.3;">' + it.product_title + '</div>' +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<div style="font-size:12px;color:#6D7A63;font-weight:600;">' + it.variant_title + '</div>' : '') +
            '<div style="display:flex;align-items:center;gap:10px;margin-top:8px;">' + controls + '</div>' +
          '</div>' +
          priceCell +
        '</div>';
      }).join('');
    }
    if (subtotal) {
      var giftTotal = cart.items.reduce(function (s, it) { return s + (isGiftLine(it) ? it.final_line_price : 0); }, 0);
      subtotal.textContent = THB(cart.total_price - giftTotal);
    }
  }


  /* ---------- Cart upsells: see em-upsell.js ---------- */

  function fetchCart() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart); }
  window.emRenderCart = renderCart;
  window.emFetchCart = fetchCart;

  function openDrawer() {
    var d = qs('#em-cart-drawer'), o = qs('#em-cart-overlay');
    if (!d) return;
    d.style.transform = 'translateX(0)';
    o.style.opacity = '1'; o.style.pointerEvents = 'auto';
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = qs('#em-cart-drawer'), o = qs('#em-cart-overlay');
    if (!d) return;
    d.style.transform = 'translateX(105%)';
    o.style.opacity = '0'; o.style.pointerEvents = 'none';
    document.body.style.overflow = '';
  }
  window.emOpenCart = function () { return fetchCart().then(openDrawer); };

  function addToCart(variantId, qty, props) {
    var body = { id: parseInt(variantId, 10), quantity: qty || 1 };
    if (props) body.properties = props;
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.text().then(function (t) {
        var j = null; try { j = JSON.parse(t); } catch (e) {}
        if (!r.ok || !j) throw new Error((j && (j.description || j.message)) || (TH ? 'ระบบไม่ตอบสนอง กรุณาลองอีกครั้ง' : 'Something went wrong, please try again.'));
        return j;
      });
    }).then(function () { return fetchCart(); }).then(openDrawer);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-em-qty]') : null;
    if (t) {
      var parts = t.getAttribute('data-em-qty').split('|');
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parts[0], quantity: parseInt(parts[1], 10) })
      }).then(function (r) { return r.json(); }).then(renderCart);
      return;
    }
    if (e.target.closest && e.target.closest('[data-em-cart-open]')) { e.preventDefault(); window.emOpenCart(); }
    if (e.target.closest && e.target.closest('[data-em-cart-close]')) closeDrawer();
  });

  /* ---------- Buy boxes ----------
     Container: [data-em-buybox]
     Option buttons inside: [data-em-option] with data-variant, data-price (display string), optional data-qty (line qty)
     Price display: [data-em-price]; CTA: [data-em-add] (appends " · price" if data-em-add-price)
  */
  qsa('[data-em-buybox]').forEach(function (box) {
    var opts = qsa('[data-em-option]', box);
    var current = opts.filter(function (b) { return b.getAttribute('data-selected') === 'true'; })[0] || opts[0];
    function apply(sel) {
      current = sel;
      opts.forEach(function (b) {
        var on = b === sel;
        b.style.background = on ? '#EAF4D4' : '#FBF6EC';
        b.style.border = on ? '2px solid #0B5A2B' : '2px solid rgba(11,90,43,0.15)';
      });
      var p = qs('[data-em-price]', box);
      if (p && sel.getAttribute('data-price')) p.textContent = sel.getAttribute('data-price');
      var cmp = qs('[data-em-compare]', box);
      if (cmp && sel.getAttribute('data-compare')) cmp.textContent = sel.getAttribute('data-compare');
      var sv = qs('[data-em-save]', box);
      if (sv && sel.getAttribute('data-save')) sv.textContent = (TH ? 'ประหยัด ' : 'SAVE ') + sel.getAttribute('data-save');
      var add = qs('[data-em-add]', box);
      if (add) {
        var base = TH ? (add.getAttribute('data-em-add-label-th') || 'เพิ่มลงตะกร้า') : (add.getAttribute('data-em-add-label') || 'Add to cart');
        add.textContent = base + ' · ' + sel.getAttribute('data-price');
      }
    }
    opts.forEach(function (b) {
      b.addEventListener('click', function () { apply(b); });
    });
    if (current) apply(current);
    var add = qs('[data-em-add]', box);
    if (add) add.addEventListener('click', function () {
      if (!current) return;
      add.disabled = true; var orig = add.textContent; add.textContent = TH ? 'กำลังเพิ่ม…' : 'Adding…';
      addToCart(current.getAttribute('data-variant'), parseInt(current.getAttribute('data-qty') || '1', 10))
        .catch(function (err) {
          var msg = box.querySelector('[data-em-err]');
          if (!msg) {
            msg = document.createElement('div');
            msg.setAttribute('data-em-err', '');
            msg.setAttribute('role', 'alert');
            msg.style.cssText = 'margin-top:10px;background:#FDECEA;color:#B3261E;border-radius:12px;padding:10px 14px;font-size:13px;font-weight:600;';
            add.insertAdjacentElement('afterend', msg);
          }
          msg.textContent = err.message;
          setTimeout(function () { if (msg.parentNode) msg.parentNode.removeChild(msg); }, 6000);
        })
        .then(function () { add.disabled = false; add.textContent = orig; });
    });
  });

  /* ---------- Accordions ---------- */
  /* thumbnail -> hero swap */
  qsa('.pdp-thumbs img').forEach(function (thumb) {
    thumb.style.cursor = 'pointer';
    thumb.addEventListener('click', function () {
      var hero = thumb.closest('.pdp-hero');
      if (!hero) return;
      var main = hero.querySelector('div[style*="border-radius: 30px"] > img:last-of-type') || hero.querySelector('img');
      if (!main || main === thumb) return;
      var src = thumb.getAttribute('src').replace(/([?&])width=\d+/, '$1width=1000');
      if (main.getAttribute('src') !== src) main.setAttribute('src', src);
    });
  });

  qsa('[data-em-acc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      var icon = qs('[data-em-acc-icon]', btn);
      var open = !panel.hidden;
      panel.hidden = open;
      btn.setAttribute('aria-expanded', String(!open));
      if (icon) icon.innerHTML = open ? '+' : '−';
    });
  });

  /* ---------- Videos: force muted autoplay ---------- */
  function kickVideos() {
    qsa('video').forEach(function (v) {
      if (!v.muted) { v.muted = true; v.setAttribute('muted', ''); }
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }
  window.addEventListener('load', kickVideos);
  try {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { if (!v.muted) { v.muted = true; v.setAttribute('muted', ''); } var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) { v.pause(); }
      });
    }, { threshold: 0.1 });
    qsa('video').forEach(function (v) { vio.observe(v); });
  } catch (e) { setInterval(kickVideos, 1500); }

  /* ---------- Section reveal ---------- */
  try {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.style.opacity = '1'; en.target.style.transform = 'none'; io.unobserve(en.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    qsa('main section').forEach(function (el) {
      el.style.opacity = '0'; el.style.transform = 'translateY(22px)';
      el.style.transition = 'opacity .7s ease, transform .7s ease';
      io.observe(el);
    });
    setTimeout(function () {
      qsa('main section').forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'none'; });
    }, 1500);
  } catch (err) {}

  /* ---------- style-hover attributes ---------- */
  qsa('[style-hover]').forEach(function (el) {
    var hover = el.getAttribute('style-hover');
    var base = el.getAttribute('style') || '';
    el.addEventListener('mouseenter', function () { el.setAttribute('style', base + ';' + hover); });
    el.addEventListener('mouseleave', function () { el.setAttribute('style', base); });
  });

  /* ---------- Guarantee banner under every buy CTA ---------- */
  qsa('[data-em-buybox]').forEach(function (box) {
    if (box.querySelector('[data-em-guarantee]') || box.querySelector('div[style*="EAF4D4"]')) return;
    var add = qs('[data-em-add]', box);
    if (!add) return;
    var d = document.createElement('div');
    d.setAttribute('data-em-guarantee', '');
    d.style.cssText = 'display:flex;align-items:center;gap:8px;margin-top:14px;background:#EAF4D4;border-radius:12px;padding:11px 14px;';
    d.innerHTML = '<span style="font-size:18px;">💰</span><span style="font-size:13px;color:#16321F;font-weight:700;">' + (TH ? 'ถูกใจหรือคืนเงิน รับประกัน 21 วัน' : 'Love it or your money back, 21-day guarantee.') + '</span>';
    add.insertAdjacentElement('afterend', d);
  });

  /* ---------- PDP sticky add-to-cart bar ---------- */
  (function () {
    var sb = document.getElementById('stickybar');
    if (!sb) return;
    var box = qs('[data-em-buybox]');
    function show(v) { sb.style.transform = v ? 'translateY(0)' : 'translateY(110%)'; }
    if (box) {
      try {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            show(!en.isIntersecting && en.boundingClientRect.top < 0);
          });
        }, { threshold: 0 }).observe(box);
      } catch (e) { show(true); }
    } else {
      show(true);
    }
    var cta = sb.querySelector('a, button');
    if (cta) cta.addEventListener('click', function (ev) {
      ev.preventDefault();
      var add = box ? qs('[data-em-add]', box) : null;
      if (add && !add.disabled) { add.click(); }
      else if (box) { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      else { window.scrollTo({ top: 0, behavior: 'smooth' }); }
    });
  })();

  /* ---------- Init cart badge ---------- */
  fetchCart();
})();
